export const PAGE_BLOCK_SIZE = 10;

export const getPageBlockNumbers = (currentPage, totalPages, blockSize = PAGE_BLOCK_SIZE) => {
  const total = Math.max(totalPages, 1);
  const blockStart = Math.floor(currentPage / blockSize) * blockSize;
  const blockEnd = Math.min(blockStart + blockSize - 1, total - 1);

  return Array.from({ length: blockEnd - blockStart + 1 }, (_, index) => blockStart + index);
};

export const getPreviousBlockPage = (currentPage, blockSize = PAGE_BLOCK_SIZE) =>
  Math.max(0, currentPage - blockSize);

export const getNextBlockPage = (currentPage, totalPages, blockSize = PAGE_BLOCK_SIZE) => {
  const lastPage = Math.max(totalPages, 1) - 1;
  return Math.min(lastPage, currentPage + blockSize);
};
